const rootSelector = '.c-accordion';

function init() {
  const accordions = document.querySelectorAll(rootSelector);

  if (!accordions.length) {
    return;
  }

  Array.from(accordions).forEach((accordion) => {
    buildAccordion(accordion);
  });
}

function buildAccordion(accordion) {
  const items = accordion.querySelectorAll(`${rootSelector}__item`);

  Array.from(items).forEach((item) => {
    const title = item.querySelector(`${rootSelector}__title`);

    title.addEventListener('click', (e) => {
      e.preventDefault();
      setActive(item);
    });
  });
}

function setActive(item) {
  const content = item.querySelector(`${rootSelector}__content`);
  const description = item.querySelector(`${rootSelector}__description`);

  if (item.classList.contains('is-active')) {
    content.style.height = '0px';
    item.classList.remove('is-active');
  } else {
    const { height } = description.getBoundingClientRect();
    content.style.height = `${height}px`;
    item.classList.add('is-active');
  }
}

function resizeItems() {
  const items = document.querySelectorAll(`${rootSelector}__item`);

  if (!items.length) {
    return;
  }

  Array.from(items).forEach((item) => {
    const content = item.querySelector(`${rootSelector}__content`);
    const description = item.querySelector(`${rootSelector}__description`);

    if (item.classList.contains('is-active')) {
      const { height } = description.getBoundingClientRect();
      content.style.height = `${height}px`;
    }
  });
}

window.addEventListener('resize', () => {
  resizeItems();
});

export default init;
